export default {
    modal: {
        title: 'SISTEMA DE CASAS',
        subTitle: 'Qual sistema deseja usar?',

        personalArea: 'Altere o sistema de cálculo do seu Mapa Astral e de todos os Mapas Extras gerados a partir de agora. Você pode reverter essa mudança a qualquer momento.',
        extraMap: 'Altere o sistema de cálculo desse Mapa Extra. Seus mapas continuarão sendo gerados no sistema padrão, a não ser que você altere essa configuração no seu perfil.',

        placidus: {
            title: 'Placidus',
            description: 'A posição exata do Ascendente marca a cúspide da casa 1 e as cúspides seguintes são medidas em intervalos de duas horas, resultando em casas de tamanhos diferentes e permitindo que hajam casas interceptadas. É o sistema mais popular no mundo por ser muito detalhado e funciona melhor quanto mais perto da linha do equador.'
        },

        wholeSigns: {
            title: 'Signos Iguais (Whole Signs)',
            description: 'O início do signo do Ascendente marca a cúspide da casa 1 e assim as casas seguintes são distribuídas em intervalos iguais de 30 graus. É o método mais antigo, mais fácil de calcular e interpretar e funciona para qualquer latitude.'
        },

        knowMore: "Saiba mais sobre os <a href='/artigo/historia-casas-astrologicas'>Sistemas de Casas Astrológicas</a>",
        change: 'Alterar',
        cancel: 'Cancelar',
        error: 'Não foi possível alterar o sistema de casas agora. Tente novamente em alguns instantes.',
        success: 'Sistema de casas alterado com sucesso! Atualizando o seu mapa…',
        sessionExpired: 'Sua sessão foi atualizada em outra aba. Recarregue a página e tente novamente.'
    }
};
